import React from "react";
import { getSecureItem } from "../../../utilsFunctions";
import { ImageBaseUrl } from "../../../Environment";
import pdfMake from "../pdfmakeWrapper";
import moment from "moment";

// Convert image URL to base64
function getBase64ImageFromUrl(url) {
  return fetch(url, { mode: "cors" })
    .then((response) => {
      if (!response.ok) throw new Error("Network response was not ok");
      return response.blob();
    })
    .then(
      (blob) =>
        new Promise((resolve, reject) => {
          const reader = new FileReader();
          reader.onloadend = () => resolve(reader.result);
          reader.onerror = reject;
          reader.readAsDataURL(blob);
        })
    );
}

const PdfReportDisburse = ({
  sortedData,
  totalAmtD,
  loanTenure,
  companyData,
}) => {  
  const getAddress = (address) =>
    [
      address?.AddressStreet,
      address?.AddressLandmark,
      address?.AddressCity,
      address?.AddressState,
      address?.AddressPincode,
    ]
      .filter(Boolean)
      .join(", ");

  const imageUrl =
    getSecureItem("loggedinUserCompany") === "1365"
      ? "https://i.imghippo.com/files/CCD2780qQ.jpeg"
      : `${ImageBaseUrl}${companyData?.profilePic}`;

  getBase64ImageFromUrl(imageUrl)
    .then((imageBase64) => buildAndDownloadPdf(imageBase64))
    .catch((err) => {
      console.warn("Image load failed, continuing without logo:", err);
      buildAndDownloadPdf(null);
    });

  function buildAndDownloadPdf(imageBase64) {
    const headerSection = [
      {
        table: {
          widths: ["*"],
          body: [
            [
              {
                columns: [
                  imageBase64
                    ? { image: imageBase64, width: 60, height: 70 }
                    : {
                        text: "LOGO",
                        width: 60,
                        height: 70,
                        alignment: "center",
                        color: "#aaa",
                      },
                  {
                    width: "*",
                    alignment: "center",
                    stack: [
                      { text: companyData.companyName, style: "companyName" },
                      {
                        text: `Address: ${getAddress(companyData.address)}`,
                        style: "infoText",
                      },
                      {
                        text: `GSTIN: ${companyData.GstIn || ""} | Website: ${companyData.companyWebsite || ""}`,
                        style: "infoText",
                      },
                      {
                        text: `Mobile No: ${companyData.phone} | Email ID: ${companyData.companyMail}`,
                        style: "infoText",
                      },
                    ],
                  },
                ],
                columnGap: 10,
              },
            ],
          ],
        },
        layout: { hLineWidth: () => 1, vLineWidth: () => 1 },
        margin: [0, 0, 0, 10],
      },
    ];

    const filterSection = [
      { text: "Disbursement Report", style: "title" },
      { text: `Total Disbursed Amount: ${totalAmtD}`, style: "filter" },
      { text: `Sequence: ${loanTenure}`, style: "filter", margin: [0, 0, 0, 20], },
    ].map((item) => ({ ...item, alignment: "center" }));

    const tableHeaders = [
      "Sr. No.",
      "Loan Id",
      "Borrower Name",
      "Area/Line",
      "Lent Amount",
      "Processing Fee",
      "Installment Amount",
      "Approved Date",
      "Disbursed Date",
      "First Due Date",
      "Assigned To",
    ];

    const tableBody = [
      tableHeaders.map((header) => ({
        text: header,
        style: "tableHeader",
        alignment: "center",
      })),
      ...sortedData.map((data, index) => {
        const borrowerName = `${data?.customer?.firstName} ${data?.customer?.lastName}`;
        const custId = data?.customer?.cust_id
          ? ` (${data?.customer?.cust_id})`
          : "";
        const sourceName = data?.customer?.user ? data?.customer?.user?.firstName + " " + data?.customer?.user?.lastName : "";
        return [
          index + 1,
          data.loanId ?? "N/A",
          borrowerName + custId + (data?.customer?.phone ? ` (${data.customer.phone})` : ""),
          data?.customer?.areaLine ?? "N/A",
          data.loanAmount ?? "N/A",
          data.processFee ?? "N/A",
          data?.collectionAmount ?? "N/A",
          data?.approvalDate ? moment(data.approvalDate).format("DD/MM/YYYY") : "N/A",
          data?.disbursedDate ? moment(data.disbursedDate).format("DD/MM/YYYY") : "N/A",
          data?.startDate
            ? moment(data.startDate).format("DD/MM/YYYY")
            : "N/A",
          data?.user
            ? `${data.user.firstName} ${data.user.lastName}`
            : "N/A"
        ];
      }),
    ];

    const docDefinition = {
      pageOrientation: "landscape",
      content: [
        ...headerSection, // array
        ...filterSection, // array
        {
          table: {
            headerRows: 1,
            widths: ["auto", "auto", "auto", "auto", "auto", "auto", "auto", "auto", "auto", "auto", "auto"],
            body: tableBody,
          },
          layout: {
            fillColor: (rowIndex) => (rowIndex === 0 ? "#f0f0f0" : null),
          },
          dontBreakRows: false,
        },
      ],
      styles: {
        title: {
          fontSize: 16,
          bold: true,
          marginBottom: 10,
        },
        filter: {
          fontSize: 10,
          marginBottom: 2,
        },
        companyName: {
          fontSize: 14,
          bold: true,
          marginBottom: 4,
          marginTop: 5,
        },
        infoText: {
          fontSize: 9,
          lineHeight: 1.3,
        },
        tableHeader: {
          fontSize: 10,
          bold: true,
        },
      },
      defaultStyle: {
        alignment: "center",
        fontSize: 9,
      },
      pageMargins: [10, 10, 10, 10],
    };

    pdfMake.createPdf(docDefinition).download("DisburseReport.pdf");
  }
};

export default PdfReportDisburse;
